import { defaultTemplateResource } from './resource';
export const computeDefaultTemplateLabel = (productType, process, sharingId) => `${productType}/${process}/${sharingId}`;
export const computeDefaultTemplatesLabel = sharingId => `${sharingId}`;
export const fetchDefaultTemplate = ({
  productType,
  process,
  sharingId
}) => {
  const url = `/templates/templates/defaults/${productType}_${process}`;
  const label = computeDefaultTemplateLabel(productType, process, sharingId);
  return defaultTemplateResource.fetchOne(url, {
    label,
    params: {
      sharing_id: sharingId
    },
    on20X: response => response,
    // the default may not exists, it's not an error
    not20X: response => response
  });
};
export const fetchDefaultTemplates = ({
  sharingId
}) => {
  const url = '/templates/templates/defaults';
  const label = computeDefaultTemplatesLabel(sharingId);
  return defaultTemplateResource.fetch(url, {
    label,
    params: {
      sharing_id: sharingId
    }
  });
};
export const setDefaultTemplate = ({
  productType,
  process,
  templateId,
  sharingId
}) => dispatch => {
  const label = computeDefaultTemplateLabel(productType, process, sharingId);
  const url = `/templates/templates/defaults/${productType}_${process}`;
  const data = {
    template: templateId
  };
  return dispatch(defaultTemplateResource.post(url, data, {
    label,
    params: {
      sharing_id: sharingId
    }
  })).then(response => {
    // $FlowFixMe[unused-promise]
    // $FlowFixMe[incompatible-call]: looks like InvalidateAction<> is not compat with actual action
    dispatch(defaultTemplateResource.invalidate());
    return response;
  });
};
export const deleteDefaultTemplate = ({
  productType,
  process,
  sharingId
}) => dispatch => {
  const label = computeDefaultTemplateLabel(productType, process, sharingId);
  const url = `/templates/templates/defaults/${productType}_${process}`;
  return dispatch(defaultTemplateResource.deleteOne(url, {
    label,
    params: {
      sharing_id: sharingId
    }
  })).then(response => {
    // $FlowFixMe[unused-promise]
    // $FlowFixMe[incompatible-call]: looks like InvalidateAction<> is not compat with actual action
    dispatch(defaultTemplateResource.invalidate());
    return response;
  });
};